import angular from "angular";

angular
    .module('app')
    .component('freeSignUp', {
        template: require('./free-sign-up.html'),
        controller: ['$http', 'Notifier', 'trans', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, trans) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.type = $ctrl.resolve.type;
        $ctrl.group = $ctrl.resolve.group;
    };

    $ctrl.confirm = function () {
        $ctrl.loading = false;
        $http
            .post(`/courses/${$ctrl.course.id}/free-sign-up`, {
                type: $ctrl.type,
                group_id: $ctrl.group ? $ctrl.group.id : ''
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success(trans('Success signed up for course'), 3);
                    $ctrl.close();
                },
                function (error) {
                    $ctrl.loading = false;
                }
            )
    }

}
